import { createLookup, isArrayEmpty, react } from "../../../omnia"
import { TerramapContext } from "../../context"
import { getFieldSelectionContext } from "../../fieldSelectionContext"
import { State } from "../../state"
import { Field } from "./Field"
import classes = react.classes
import { Selection } from "../../types"

type Group = Selection["groups"][number]

interface Props {
    state: State
}

export function FieldGroups({ state }: Props) {

    const { dispatch } = React.useContext(TerramapContext)
    const { selection: { groups }, tasks } = state

    const selectionContext = useSelectionContext(state)
    const enableSelection = !!selectionContext

    const tasksByFieldId = createLookup(tasks, t => t.payload.fieldId)

    if (isArrayEmpty(groups)) {
        return null
    }

    return <div className="field-groups">

        <div>
            {groups.map(g => <Group key={g.key} group={g} />)}
        </div>

    </div>

    function Group({ group }: { group: Group }) {

        const { key } = group

        const selected = enableSelection && selectionContext.isGroupSelected(key)

        const handleClick = () => {
            if (enableSelection) {
                selectionContext.selectGroup(key, !selected)
            }
        }

        const copyParameters = (e: React.MouseEvent) => {
            e.stopPropagation()
            dispatch({ type: "updateParameters", update: group.parameters })
        }

        return <div key={group.key} className="group">

            <h2 onClick={handleClick} className={classes(enableSelection && "selectable", selected && "selected")}>

                {
                    enableSelection &&
                    <i className={classes(selected ? "fas fa-check" : "far fa-square")} />
                }

                {group.label}

                {
                    enableSelection &&
                    <button type="button" className="btn btn-icon transparent" onClick={copyParameters}>
                        <i className="far fa-copy" />
                    </button>
                }

            </h2>

            {group.fields.map(f =>

                <Field
                    key={f.field.fieldId}
                    field={f}
                    tasks={tasksByFieldId[f.fieldId]}
                    selectionContext={selectionContext}
                    layerTypes={state.reference.layerTypes}
                    focused={f.key === state.selectedFieldKey}
                />

            )}

        </div>

    }

}



function useSelectionContext(state: State) {

    const { dispatch } = React.useContext(TerramapContext)

    const parameters = state.type === "setParameters"
        ? state.parameters
        : undefined

    return React.useMemo(() => {

        if (!parameters) {
            return
        }

        const { selection: { groups } } = state

        return getFieldSelectionContext(
            groups,
            parameters.fields,
            fields => dispatch({ type: "updateParameters", update: { fields } })
        )

    }, [parameters?.fields, dispatch])

}
